import { useState } from "react";
import ScotlandMap from "./components/ScotlandMap";
import PhotoCard from "./components/PhotoCard";


function shuffle(array) {
  const arr = [...array];

  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr;
}

function preloadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = resolve;
    img.onerror = resolve;
  });
}



const MUNROS = [
  {
    name: "An Teallach",
    lat: 57.80702,
    lng: -5.25168,
    image: process.env.PUBLIC_URL + "/images/an-teallach.JPEG",
  },
  {
    name: "Ben Alder",
    lat: 56.813809,
    lng: -4.465033,
    image: process.env.PUBLIC_URL + "/images/ben-alder.JPEG",
  },
  {
    name: "Beinn Mheadhoin",
    lat: 57.095954,
    lng:  -3.611474,
    image: process.env.PUBLIC_URL + "/images/ben-mheadhoin.JPEG",
  },
  {
    name: "Ben More",
    lat: 56.38569,
    lng: -4.53976,
    image: process.env.PUBLIC_URL + "/images/ben-more.JPEG",
  },
  {
    name: "Beinn Narnain",
    lat: 56.221445,
    lng: -4.789393,
    image: process.env.PUBLIC_URL + "/images/ben-narnain.JPEG",
  },
  {
    name: "Ben Nevis",
    lat: 56.796872,
    lng: -5.003508,
    image: process.env.PUBLIC_URL + "/images/ben-nevis.JPEG",
  },
  {
    name: "Ben Wyvis",
    lat: 57.678923,
    lng: -4.579287,
    image: process.env.PUBLIC_URL + "/images/ben-wyvis.JPEG",
  },
  {
    name: "Bruach na Frìthe",
    lat: 57.246884,
    lng: -6.210698,
    image: process.env.PUBLIC_URL + "/images/bruach-na-frtih.JPEG",
  },
  {
    name: "Ciste Dhubh",
    lat: 57.199255,
    lng:  -5.209038,
    image: process.env.PUBLIC_URL + "/images/ciste-dubh.JPEG",
  },
  {
    name: "The Inaccessible Pinnacle",
    lat: 57.213269,
    lng: -6.234698,
    image: process.env.PUBLIC_URL + "/images/inn-pinn.JPEG",
  },
  {
    name: "The Saddle",
    lat: 57.16175,
    lng: -5.41669,
    image: process.env.PUBLIC_URL + "/images/the-saddle.JPEG",
  },{
    name: "Beinn Eighe",
    lat: 57.58210,
    lng: -5.40358,
    image: process.env.PUBLIC_URL + "/images/beinn-eighe.JPEG",
  },{
    name: "Sgùrr Mhic Choinnich",
    lat: 57.209056,
    lng: -6.223888,
    image: process.env.PUBLIC_URL + "/images/sgurr-mhic-Chonich.JPEG",
  },{
    name: "Sgorr Dhearg",
    lat: 56.653915,
    lng: -5.171567,
    image: process.env.PUBLIC_URL + "/images/school-house.JPEG",
  },{
    name: "Ben Klibreck",
    lat: 58.23504,
    lng: -4.41125,
    image: process.env.PUBLIC_URL + "/images/ben-klibreck.JPEG",
  },{
    name: "Ben Vorlich",
    lat: 56.27386,
    lng: -4.75476,
    image: process.env.PUBLIC_URL + "/images/ben-vorlich.JPEG",
  },
];

function haversine(lat1, lon1, lat2, lon2) {
  const R = 6371;

  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;

  return (
    R *
    2 *
    Math.atan2(
      Math.sqrt(a),
      Math.sqrt(1 - a)
    )
  );
}

export default function App() {
  const [round, setRound] = useState(0);
  const [score, setScore] = useState(0);
  const [position, setPosition] = useState(null);
  const [result, setResult] = useState(null);
  const [gameOver, setGameOver] = useState(false);
  const [roundScores, setRoundScores] = useState([]);
  const [previousGame, setPreviousGame] = useState([]);



  const [gameMunros, setGameMunros] = useState(() =>
    shuffle(MUNROS).slice(0, 5)
  );
  
  const current = gameMunros[round];

  if (gameOver) {
    const maxScore = 5000 * gameMunros.length;
    const percentage = Math.round((score / maxScore) * 100);
  
    let title = "Nice effort!";
  
    if (percentage >= 90) title = "🏆 Munro Compleator!";
    else if (percentage >= 75) title = "🥇 Summit Bagger!";
    else if (percentage >= 60) title = "🥈 Trig Point Enthusiast!";
    else if (percentage >= 40) title = "🥉 Cairn Collector!";
  
    return (
      <div className="min-h-screen bg-slate-800 flex items-center justify-center p-6">
        <div className="max-w-xl w-full bg-white rounded-3xl shadow-2xl p-8 text-center">
          <h1 className="munro-title text-5xl mb-4 text-green-700">
            {title}
          </h1>
  
          <p className="text-xl text-slate-600 mb-6">
            You've completed all 5 rounds.
          </p>
  
          <div className="bg-green-50 rounded-2xl p-6 mb-6">
            <div className="text-sm text-slate-500">
              Final Score
            </div>
  
            <div className="text-6xl font-black text-green-600">
              {score}
            </div>
  
            <div className="mt-2 text-slate-600">
              {percentage}% of the maximum possible score
            </div>
          </div>
  
          <div className="mb-6 bg-slate-50 rounded-2xl p-4">
  <h2 className="font-bold mb-3">
    Round Summary
  </h2>

  {roundScores.map((item, index) => (
    <div
      key={index}
      className="flex justify-between py-2 border-b last:border-b-0"
    >
      <div>
        <div className="font-medium">
          {item.mountain}
        </div>

        <div className="text-sm text-slate-500">
          {item.distance} km away
        </div>
      </div>

      <div className="font-bold text-green-600">
        {item.score}
      </div>
    </div>
  ))}
</div>
  
          <button
            onClick={restartGame}
            className="
              w-full
              bg-green-600
              hover:bg-green-700
              text-white
              font-bold
              py-4
              rounded-2xl
              shadow-lg
            "
          >
            Play Again
          </button>
  
          <a
            href="https://craigsgist.com"
            className="
              block
              mt-4
              text-slate-500
              hover:text-green-600
            "
          >
            ← Return to Craig's Gist
          </a>
        </div>
      </div>
    );
  }
  

  function handleGuess() {
    if (!position) return;

    const distance = haversine(
      position.lat,
      position.lng,
      current.lat,
      current.lng
    );

    const roundScore = Math.round(
      5000 * Math.exp(-distance / 50)
    );

    setScore((s) => s + roundScore);

    setResult({
      distance: distance.toFixed(1),
      roundScore,
    });

    setRoundScores((prev) => [
      ...prev,
      {
        mountain: current.name,
        score: roundScore,
        distance: distance.toFixed(1),
      },
    ]);
  }


  async function nextRound() {
    if (round === gameMunros.length - 1) {
      setGameOver(true);
      return;
    }
  
    const nextMunro = gameMunros[round + 1];
  
    await preloadImage(nextMunro.image);
  
    setRound(round + 1);
    setPosition(null);
    setResult(null);
  }

  function restartGame() {
    const available = MUNROS.filter(
      (m) => !previousGame.some((p) => p.name === m.name)
    );
  
    const newGame = shuffle(
      available.length >= 5 ? available : MUNROS
    ).slice(0, 5);
  
    setPreviousGame(newGame);
    setGameMunros(newGame);
  
    setRound(0);
    setScore(0);
    setPosition(null);
    setResult(null);
    setRoundScores([]);
    setGameOver(false);
  }

  return (
    <div className="min-h-screen bg-slate-800">
    <div className="bg-gradient-to-r from-slate-900 via-green-800 to-slate-900 px-6 py-2 shadow-xl border-green-500/30">
    <h1 className="munro-title text-4xl md:text-5xl text-white drop-shadow-lg">
    🏔️ MunroGuessr
  </h1>

  <p className="text-green-100 text-sm font-bold italic">
  Guess the Munro from a single summit photo
</p>
</div>


      {/* Main Layout */}
      <div className="flex flex-col lg:flex-row gap-3 p-3">
        {/* Image */}
        <div
  className="
    lg:flex-1
    lg:max-h-[calc(100vh-110px)]
    overflow-hidden
    rounded-2xl
    shadow-2xl
  "
>
  <PhotoCard 
  key={current.image}
  image={current.image} />
</div>

        {/* Side Panel */}
        <div
  className="
    w-full
    lg:w-[400px]
    bg-white
    rounded-3xl
    shadow-2xl
    overflow-hidden
  "
>
<div className="p-4 border-b bg-slate-50">
  <div className="flex items-center justify-between">
    <h2 className="text-xl font-bold text-black">
    Round {round + 1} / {gameMunros.length}
    </h2>

    <div className="bg-green-600 text-white px-3 py-1 rounded-full font-bold">
      {score}
    </div>
  </div>
</div>

      

          <div className="px-4">
            <div className="h-[180px] sm:h-[220px] lg:h-[350px] rounded-xl overflow-hidden border">
            <ScotlandMap
  position={position}
  setPosition={setPosition}
  actual={
    result
      ? {
          lat: current.lat,
          lng: current.lng,
        }
      : null
  }
/>
            </div>
          </div>

          <div className="p-4">
            {!result ? (
          <button
          onClick={handleGuess}
          disabled={!position}
          className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 rounded-xl disabled:bg-gray-400"
        >
          {position ? "Guess" : "Place a pin to guess"}
        </button>
        
            ) : (
              <>
                <div className="mb-4">
                  <h3 className="font-bold text-lg">
                    {current.name}
                  </h3>

                  <p>
                    Distance: {result.distance} km
                  </p>

                  <p>
                    Score: {result.roundScore}
                  </p>
                </div>

                <button
                  onClick={nextRound}
                  className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-xl"
                >
                  Next Round
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <footer className="mt-2 px-6 py-3 text-center text-sm text-slate-400">
  <div>
    <a
      href="https://craigsgist.com"
      className="hover:text-white transition-colors"
    >
      ← Return to Craig's Gist
    </a>
  </div>

  <div className="mt-1">
    © {new Date().getFullYear()} Craig Griffin · MunroGuessr
  </div>
</footer>
    </div>
  );
}